export function formateDateTitle(title, rangesDate) {
  return deleteSpaces(
    title +
      rangesDate[0].toISOString().substring(0, 10) +
      " - " +
      rangesDate[1].toISOString().substring(0, 10)
  );
}

export function convertDate(timestamp) {
  if (!timestamp) return "Sin fecha";

  const fecha = new Date(timestamp);
  const dia = fecha.getDate();
  const mes = fecha.getMonth() + 1;
  const año = fecha.getFullYear() % 100;
  return `${dia}/${mes}/${año}`;
}

export function convertMethodPay(method) {
  const methodPay = method.toUpperCase();

  if (
    methodPay !== "EFECTIVO" &&
    methodPay !== "WALLET" &&
    methodPay !== "TARJETA"
  ) {
    return "TARJETA";
  } else {
    return methodPay;
  }
}

export function convertToFixedAndNumber(total) {
  return parseFloat(total.toFixed(2));
}
export function calculateCommisionOpenpay(totalTarifa = 0) {
  return convertToFixedAndNumber(totalTarifa * 0.0225);
}

export function calculateNetoDeposito(totalTarifa = 0) {
  return convertToFixedAndNumber(
    totalTarifa - calculateCommisionOpenpay(totalTarifa)
  );
}
export function calculateTotalSinIva(totalTarifa = 0) {
  return convertToFixedAndNumber(totalTarifa / 1.16);
}
export function calculateIva(totalTarifa = 0, porcentage = 0) {
  return convertToFixedAndNumber(
    calculateTotalSinIva(totalTarifa) * porcentage
  );
}

export function calculateDifIVA(totalTarifa = 0, porcentage = [0, 0]) {
  return convertToFixedAndNumber(
    calculateIva(totalTarifa, porcentage[0]) -
      calculateIva(totalTarifa, porcentage[1])
  );
}
export function calculateIsr(totalTarifa = 0, porcentage = 0) {
  return convertToFixedAndNumber(totalTarifa * porcentage);
}
export function calculateDifISR(totalTarifa = 0, porcentages = [0, 0]) {
  return convertToFixedAndNumber(
    calculateIsr(totalTarifa, porcentages[0]) -
      calculateIsr(totalTarifa, porcentages[1])
  );
}
export function calculateUsoPlataforma(totalTarifa = 0, porcentage = 0) {
  return totalTarifa * porcentage;
}
export function calculateCommission(totalTarifa = 0, porcentage = 0) {
  return convertToFixedAndNumber(totalTarifa * porcentage);
}

export function calculateTarifadelviaje(
  dynamic = 0,
  base = 0,
  tariffduration = 0,
  tariffdistance = 0
) {
  return convertToFixedAndNumber(
    (base + tariffduration + tariffdistance) * dynamic
  );
}
export function deleteSpaces(str) {
  return str.replace(/\s/g, "");
}

export function totalgetNiku(
  cuota = 0,
  iva8 = 0,
  isr21 = 0,
  usoplat = 0,
  commission = 0
) {
  return convertToFixedAndNumber(cuota + iva8 + isr21 + usoplat + commission);
}
